import { type FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFilter } from "@/partner/shared/components/Filter";
import { SimpleTableCard } from "@/partner/shared/components/SimpleTableCard";
import { formatNumber } from "@/shared/utils/formatNumber";
import { formatCurrency } from "@/partner/features/products";
import { useAnalyticsSalesByEmailCampaignQuery } from "@/partner/entities/analytics";
import { DownloadReportButton } from "@/partner/features/reports";
import {
  AnalyticsWidgetType,
  ReportTypeType,
} from "@/types/graphql/partner.generated";

export const AnalyticsSalesByEmailCampaignTable: FC = () => {
  const { t } = useTranslation();
  const { filter } = useFilter();
  const [limit, setLimit] = useState(10);

  const { data, loading, error } = useAnalyticsSalesByEmailCampaignQuery({
    variables: { filter: filter as never, limit },
  });

  const currency = data?.analyticsSales.currency ?? "USD";
  const rows = (data?.analyticsSales.salesByEmailCampaign ?? []).map((row) => [
    row.title || t("shared.attribution.deletedCampaign"),
    formatNumber(row.sales),
    formatCurrency(row.revenue, currency),
  ]);

  return (
    <SimpleTableCard
      title={t("analytics.sales.tableByEmailCampaign")}
      // Продления считаются и по счетам Stripe Billing, и по повторным
      // оплатам подписки, пришедшей по письму.
      subheader={t("analytics.sales.emailCampaignRenewalsHint")}
      columns={[
        { name: t("analytics.columnEmailCampaign"), minWidth: 200 },
        { name: t("analytics.sales.columnSales") },
        { name: t("analytics.sales.columnRevenue") },
      ]}
      rows={rows}
      loading={loading}
      error={error}
      limit={limit}
      setLimit={setLimit}
      downloadButton={
        <DownloadReportButton
          variant="card"
          type={ReportTypeType.AnalyticsWidgetType}
          widget={AnalyticsWidgetType.SalesByEmailCampaignType}
          filter={filter}
        />
      }
    />
  );
};
